type DebugWindow = Window & { DEBUG_LOGS?: boolean };

export interface TTSPrefs {
  tts: boolean;
  ttsCheckIn: string;
  ttsCheckOut: string;
  notifications: boolean;
  language: string;
}

export function getTTSAndNotificationPrefs(): TTSPrefs {
  try {
    const labsSettings = JSON.parse(localStorage.getItem('labs_settings') || '{}');
    const userPrefs = JSON.parse(localStorage.getItem('user_prefs') || '{}');
    if ((window as DebugWindow).DEBUG_LOGS) {
      console.debug('[labs/tts] TTS check:', { labsSettings, userPrefs });
    }
    return {
      tts: !!labsSettings.useTTS,
      ttsCheckIn: labsSettings.ttsCheckIn || 'Bem-vindo! Registro de entrada realizado.',
      ttsCheckOut: labsSettings.ttsCheckOut || 'Até logo! Registro de saída realizado.',
      notifications: !!userPrefs.notificationsEnabled,
      language: userPrefs.language || 'pt-BR',
    };
  } catch (e) {
    console.error('[labs/tts] Error reading TTS prefs:', e);
    return { tts: false, ttsCheckIn: '', ttsCheckOut: '', notifications: false, language: 'pt-BR' };
  }
}

export function speakTTS(text: string, lang: string) {
  if ((window as DebugWindow).DEBUG_LOGS) {
    console.debug('[labs/tts] TTS attempt:', { text, lang, supported: 'speechSynthesis' in window });
  }
  if ('speechSynthesis' in window) {
    try {
      const utter = new window.SpeechSynthesisUtterance(text);
      utter.lang = lang;
      utter.rate = 0.9;
      utter.volume = 1.0;
      utter.onstart = () => { if ((window as DebugWindow).DEBUG_LOGS) console.debug('[labs/tts] TTS started'); };
      utter.onend = () => { if ((window as DebugWindow).DEBUG_LOGS) console.debug('[labs/tts] TTS ended'); };
      utter.onerror = (event) => { console.error('[labs/tts] TTS error:', event); };
      window.speechSynthesis.speak(utter);
    } catch (e) {
      console.error('[labs/tts] TTS error:', e);
    }
  } else {
    console.warn('[labs/tts] Speech synthesis not supported');
  }
}
